/* Copyright Verge Technologies 2018
 * @file requestQuote.js
 * @author Brenton Watt <brenton@verge.co.za>
 * @description Component responsible for quote form
 */

// Modules
import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import _ from 'lodash';
import validator from 'validator';
import PropTypes from 'prop-types';

// GraphQL
import { REQUEST_QUOTE } from '../../graphql';

// Components

class RequestQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      firstNameError: false,
      lastName: '',
      lastNameError: false,
      email: '',
      emailError: false,
      contactNumber: '',
      contactNumberError: false,
      companyName: '',
      companyNameError: false,
      additional: '',
    };
  }

  getOrder = () => {
    // return the favourites stored in client local storage
    const keyMap = {
      hash_id: 'id',
      quantity: 'quantity',
    };
    const returnFavourites = [];
    this.props.favourites.map((favourite) => {
      let temp = _.pick(favourite, ['hash_id', 'quantity']);
      temp = _.mapKeys(temp, (value, key) => keyMap[key]);
      if (!_.isEmpty(temp)) {
        returnFavourites.push(temp);
      }
      return null
    });
    return returnFavourites;
  };

  updateDetails = (e) => {
    const field = {
      ...this.state,
      firstNameError: false,
      lastNameError: false,
      emailError: false,
      contactNumberError: false,
      companyNameError: false,
    };
    field[e.target.name] = e.target.value;
    this.setState(field);
  };

  checkFields = () => {
    const {
      firstName, lastName, email, contactNumber, companyName, 
    } = this.state;

    // Check that a first name has been entered
    if (firstName === null || _.isUndefined(firstName) || firstName.length < 1) {
      this.setState({
        ...this.state,
        firstNameError: true,
      });
      return false;
    }

    // Check that a valid last name has been entered
    if (lastName === null || _.isUndefined(lastName) || lastName.length < 1) {
      this.setState({
        ...this.state,
        lastNameError: true,
      });
      return false;
    }

    // Check for valid email
    if (!validator.isEmail(email)) {
      this.setState({
        ...this.state,
        emailError: true,
      });
      return false;
    }

    // Check for valid contactNumber
    if (!validator.isMobilePhone(contactNumber)) {
      this.setState({
        ...this.state,
        contactNumberError: true,
      });
      return false;
    }

    // Check that company name passed is valid
    if (companyName === null || _.isUndefined(companyName) || companyName.length < 1) {
      this.setState({
        ...this.state,
        companyNameError: true,
      });
      return false;
    }

    return true;
  };

  handleSubmit = (event, mutation) => {
    if (!this.checkFields()) {
      return;
    }

    event.preventDefault();
    mutation();
    this.setState({
      ...this.state,
      firstName: '',
      firstNameError: false,
      lastName: '',
      lastNameError: false,
      email: '',
      emailError: false,
      contactNumber: '',
      contactNumberError: false,
      companyName: '',
      companyNameError: false,
      additional: '',
    });
  };

  render() {
    return (
      <Mutation
        mutation={REQUEST_QUOTE}
        variables={{
          params: {
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            contact_number: this.state.contactNumber,
            company_name: this.state.companyName,
            additional_query: this.state.additional,
            order: this.getOrder(),
          },
        }}
      >
        {(postMutation, { data, loading, error }) => {
          if (!loading && !error && data) {
            // Reset local storage
            localStorage.setItem('SEPARATIONS_FAVOURITES', JSON.stringify([]));
            // Redirect to thank you page
            this.props.history.push('/favourites/request-quote/thank-you');
          }
          return (
            <div className="request-container">
              <div className="summary">
                <h4>List Summary</h4>
                <ul className="products">
                  {this.props.favourites.map((favourite) => {
                    return (
                      <li key={favourite.hash_id}>
                        {favourite.name}
                      </li>
                    );
                  })}
                </ul>
                <hr />
                <div className="details">
                  Products:{' '}
                  <b>
                    <span>{this.props.favourites.length}</span>
                  </b>
                  <br />
                  Units:{' '}
                  <b>
                    <span>{this.props.favourites.reduce((sum, favourite) => sum + favourite.quantity, 0)}</span>
                  </b>
                </div>
              </div>
              <div className="form">
                <form name="request-form">
                  <div className="row">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First name"
                      value={this.state.firstName}
                      onChange={e => this.updateDetails(e)}
                    />
                    {
                      this.state.firstNameError ? <label className="error">Please enter your name</label> : ''
                    }
                  </div>
                  <div className="row">
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last name"
                      value={this.state.lastName}
                      onChange={e => this.updateDetails(e)}
                    />
                    {
                      this.state.lastNameError ? <label className="error">Please enter your last name</label> : ''
                    }
                  </div>
                  <div className="row">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email address"
                      value={this.state.email}
                      onChange={e => this.updateDetails(e)}
                    />
                    {
                      this.state.emailError ? <label className="error">Please enter a valid email address</label> : ''
                    }
                  </div>
                  <div className="row">
                    <input
                      type="text"
                      name="contactNumber"
                      placeholder="Contact number"
                      value={this.state.contactNumber}
                      onChange={e => this.updateDetails(e)}
                    />
                    {
                      this.state.contactNumberError ? <label className="error">Please enter a valid contact number</label> : ''
                    }
                  </div>
                  <div className="row">
                    <input
                      type="text"
                      name="companyName"
                      placeholder="Company name"
                      value={this.state.companyName}
                      onChange={e => this.updateDetails(e)}
                    />
                    {
                      this.state.companyNameError ? <label className="error">Please enter your company name</label> : ''
                    }
                  </div>
                  <div className="row">
                    <textarea
                      name="additional"
                      placeholder="Additional query.."
                      value={this.state.additional}
                      onChange={e => this.updateDetails(e)}
                    />
                  </div>
                  <div className="control">
                    <Link to="/favourites/request-quote" className="button button-grey">
                      Back
                    </Link>
                    <a className="button button-green" onClick={e => this.handleSubmit(e, postMutation)}>
                      Submit
                    </a>
                  </div>
                </form>
              </div>
            </div>
          );
        }}
      </Mutation>
    );
  }
}

RequestQuote.propTypes = {
  favourites: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default withRouter(RequestQuote);



// WEBPACK FOOTER //
// ./src/components/RequestQuote/requestQuote.js